module.exports = __webpack_public_path__ + "img/play.2998ec92.svg";